<ln-ln-pages-armor>
  <section body class="bg-beige bg-opacity-10">
    <div
      class="sm:border-t-opacity-10 sm:border-t-[2.5px] sm:border-t-beige sm:shadow-[0px_-2px_5px_0px_rgba(0,0,0,0.10)]">
    </div>
<ln-blog-hero></ln-blog-hero>
    <div class="mx-auto flex max-w-[1440px] flex-col justify-center">
      <div  class="flex flex-col mt-[50px]">
<!--        <div #injectBlog class="injectBlogCSS"></div>-->
        <div class="ml-[31px] flex flex-row flex-wrap gap-x-[43px] gap-y-[30px] sm:ml-[116px]">
          @for(card of articles; track $index) {
            @if(card.isVisible){
              <ln-blog-card [blogPostInterface]="card"></ln-blog-card>
            }
          }
        </div>
      </div>
      <div class="flex items-center border-b-[2px] border-b-verde opacity-40 mt-[40px] mx-[36px] sm:mx-[120px]"></div>
    </div>
  </section>
</ln-ln-pages-armor>
